

//hippa october update


import React, { useState, useEffect } from "react";
import { db } from "../../firebase-config";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ref, onValue} from "firebase/database";
import { ToastContainer, toast } from "react-toastify";
import CryptoJS from "crypto-js"; // Ensure CryptoJS is imported
import { update } from "firebase/database"; 


const initialState = {
    DoctorAssigned: "",
    ID: "",
    FullName: "",
    Role: "",
    Age: "",
};


// Function to encrypt data using CryptoJS and secret key
const encryptData = (data, keyIdentifier = "default") => {
  try {
    const secretKey = getDecryptionKey(keyIdentifier);
    const encryptedData = CryptoJS.AES.encrypt(data, secretKey).toString();
    return encryptedData;
  } catch (error) {
    console.warn("Error encrypting data, returning original data:", error);
    return data; // Return original data if encryption fails
  }
};

// Function to get the decryption key based on the key identifier
const getDecryptionKey = (keyIdentifier) => {
    const keys = {
        default: process.env.REACT_APP_SECRET_KEY,
    };
    return keys[keyIdentifier] || keys["default"];
};

// Function to decrypt data using CryptoJS and secret key
const decryptData = (encryptedData, keyIdentifier = "default") => {
    try {
        const secretKey = getDecryptionKey(keyIdentifier);
        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        return decryptedData;
    } catch (error) {
        console.warn("Error decrypting data, returning original data:", error);
        return encryptedData; // Return original data if decryption fails
    }
};



const decryptDataIfNeeded = (data, keyIdentifier = "default") => {
  if (typeof data === "string") {
      try {
          const decryptedData = decryptData(data, keyIdentifier);
          // Try to decode to UTF-8 and return decrypted data if successful
          if (decryptedData && decodeURIComponent(escape(decryptedData))) {
              return decryptedData;
          }
      } catch (error) {
          console.warn(`Decryption failed or data is not a valid UTF-8 string: ${data}, returning original data. Error:`, error);
          return data;
      }
  }
  return data;
};

function UpdatePagePatient() {
    const [state, setState] = useState(initialState);
    const [data, setData] = useState({});
    const [doc, setDoc] = useState();

    const { ID, FullName, Role, DoctorAssigned, Age } = state;
    const navigate = useNavigate();
    const { id } = useParams();

    var adminName1 = localStorage.getItem("adminName");

    useEffect(() => {
        const users = ref(db, `superadmin/admins/${adminName1}/patients`);
        onValue(users, (snapshot) => {
            if (snapshot.exists()) {
                const rawData = snapshot.val();
                const decryptedData = Object.keys(rawData).reduce((acc, key) => {
                    acc[key] = {
                        ...rawData[key],
                        FullName: decryptDataIfNeeded(rawData[key].FullName, key), // Decrypt FullName
                        Age: decryptDataIfNeeded(rawData[key].Age, key), // Decrypt Age
                        ID: decryptDataIfNeeded(rawData[key].ID, key), 
                        // Decrypt other fields as necessary
                    };
                    return acc;
                }, {});
                setData(decryptedData);
            } else {
                setData({});
            }
        });
        return () => {
            setData({});
        };
    }, [id, adminName1]);

    useEffect(() => {
        if (id) {
            setState({ ...data[id] });
        } else {
            setState({ ...initialState });
        }

        return () => {
            setState({ ...initialState });
        };
    }, [id, data]);

    useEffect(() => {
        const docRef = ref(db, `superadmin/admins/${adminName1}/doctors`);
        onValue(docRef, (snapshot) => {
            if (snapshot.exists()) {
                setDoc({ ...snapshot.val() });
            } else {
                setDoc({});
            }
        });
        return () => {
            setData({});
        };
    }, [id, adminName1]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState({ ...state, [name]: value });
    };

    const notifySuccess = () =>
        toast.success("Patients Information Updated Successfully", {
            position: "top-center",
        });


   
   const handleSubmit = (e) => {
    e.preventDefault();
    if (!FullName || !ID || !Role || !DoctorAssigned || !Age) {
        toast.error("Please provide value in each field", {
            position: "top-center",
        });
    } else {
        // Prepare encrypted data for the fields to be updated
        const encryptedData = {
            FullName: encryptData(FullName), // Encrypt FullName
            ID: encryptData(ID), // Encrypt ID
            Age: encryptData(Age.toString()), // Encrypt Age (convert to string)
            DoctorAssigned, // Keep DoctorAssigned unencrypted
            Role, // Keep Role unencrypted
        };
// hippa logic
        // Update only the specified fields in the database
        update(
            ref(db, `superadmin/admins/${adminName1}/patients/${id}`),
            encryptedData, // Only updating specific fields
            (err) => {
                if (err) {
                    toast.error(err, {
                        position: "top-center",
                    });
                } else {
                    toast.success("Patient's Information Updated Successfully", {
                        position: "top-center",
                    });
                }
            }
        );

        notifySuccess();
        setTimeout(function () {
            navigate("/Admin/AssignDoctor");
        }, 2100);
    }
};
   
    return (
        <>
            <div className="techsidebar"></div>
            <div className="top-nav">
                <h1 style={{ fontSize: '28px', textDecoration: 'underline', marginRight: '15%', marginBottom: '2%' }}>Update Patients's Information</h1>
            </div>

            <Link to="/Admin/AssignDoctor" className="homeButton">
                <span id="backText" className="backText">Back</span>
                <i id="backIcon" className="fas fa-long-arrow-alt-left fa-lg fa-2x"></i>
            </Link>

            <div style={{ marginTop: "100px" }}>
                <form className="signupForm2" onSubmit={handleSubmit}>
                    <strong className="strongaddadmin">Patient's Name:</strong>
                    <input
                        className="inputaddadmin "
                        type="text"
                        id="FullName"
                        name="FullName"
                        placeholder="Patients's Name"
                        value={FullName || ""} // Keep value here but make it read-only
                        readOnly // This makes the field non-editable
                    />

                    <strong className="strongaddadmin">Patient's Age:</strong>
                    <input
                        className="inputaddadmin "
                        type="number"
                        id="Age"
                        name="Age"
                        placeholder="Patients's Age"
                        value={Age || ""}
                        onChange={handleInputChange}
                    />

                    <strong className="strongaddadmin">ID:</strong>
                    <input
                        className="inputaddadmin "
                        type="text"
                        id="ID"
                        name="ID"
                        placeholder="ID"
                        value={ID || ""}
                        onChange={handleInputChange}
                    />

                    <strong className="strongaddadmin">Doctor Assigned:</strong>
                    <select className="inputaddadmin" name="DoctorAssigned" id="DoctorAssigned" value={DoctorAssigned || ""} onChange={handleInputChange}>
                        {doc && Object.keys(doc).map((doctor, index) => (
                            <option key={index}>
                                {doc[doctor].Name}
                            </option>
                        ))}
                    </select>

                    <strong className="strongaddadmin">Role:</strong>
                    <input
                        className="inputaddadmin inputPN"
                        type="text"
                        id="Role"
                        name="Role"
                        placeholder="Role"
                        value={Role || ""}
                        readOnly
                        onChange={handleInputChange}
                    />

                    <input className="addimagebtn" type="submit" value="Save" />
                    <ToastContainer />
                </form>
            </div>
        </>
    );
}

export default UpdatePagePatient;
